import { combineReducers } from 'redux';
import sportscotland from './modules/sportScotlandData/reducer';

export default combineReducers({
  sportscotland,
});
